import { jsx as m } from "react/jsx-runtime";
import { createContext as v } from "react";
const d = "@gjensidige/core-analytics", g = "16.0.10", i = "not-set", r = "application_module", s = "event_module", p = {
  [r]: i,
  application_name: i,
  business_area: i,
  customer_segment: i,
  event_source: d,
  event_version: g
}, T = (n, e, o) => l({ ...e, ...n }, "link", o), w = v({
  options: { ...p }
}), h = ({ options: n, ...e }) => /* @__PURE__ */ m(w.Provider, { value: { options: n }, ...e });
let c = 0;
function l(n = {}, e, o) {
  var t;
  const a = (t = window.utag) == null ? void 0 : t[e].bind(window.utag);
  a ? o ? a(u(n), o) : a(u(n)) : c < 10 ? setTimeout(() => l(n, e), 100, c++) : console.error(`window.utag.${e} not found `, n);
}
function u(n) {
  const e = { ...p };
  return Object.entries(n).forEach(([o, t]) => {
    const a = o === "eventLabel" || o === "eventStatus", _ = o.replace(/[A-Z]/g, "_$&").toLowerCase();
    a && t && (t = `${t}`.toLowerCase().split(" ").join("-")), e[_] = t;
  }), {
    ...e,
    [s]: e[s] || e[r],
    page_pathname: e.page_pathname || $(e),
    measure_source: e.event_source,
    measure_version: e.event_version
  };
}
function $(n) {
  return `${window.location.pathname.replace(/\/$/, "")}/${n.application_name}/${n[r]}/${n.scenario_name}/${n.scenario_step}`.replace(/\/(undefined|null|not-set)/g, "").replace("/Din+side/", "/Din-side/");
}
export {
  p as DEFAULT_CONTEXT_TRACKING,
  w as TrackingContext,
  h as TrackingProvider,
  T as trackEvent
};
//# sourceMappingURL=index.js.map
